export const blockIconsHouseholdDoorFrontNew = (
	<span className='material-symbols-outlined'>door_front</span>
);
